<template>
  <LoadingWithText v-if="isLoading" />
  <div v-else>
    <div class="intro-y flex items-center mt-8">
      <PageHeader class="text-lg font-medium mr-auto" :title="$t('nav.officerDetails')" />
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <Button
          type="button"
          :to="{ name: 'Officers' }"
          class="box text-gray-700 dark:text-gray-300 flex"
        >
          {{ $t('text.back') }}
        </Button>
      </div>
    </div>

    <div class="intro-y box px-5 pt-5 mt-5">
      <OfficerInfo :officer="officer" />
      <div class="nav-tabs flex flex-col sm:flex-row justify-center lg:justify-start">
        <router-link
          :to="{ name: 'OfficerDetails' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.mainInformation') }}
        </router-link>
        <router-link
          :to="{ name: 'OfficerDetailsActiveLoans' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.activeLoans') }}
        </router-link>
        <router-link
          :to="{ name: 'OfficerDetailsOverdueLoans' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.loanOverdue') }}
        </router-link>
        <router-link
          :to="{ name: 'OfficerDetailsNotes' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.workedWithALoan') }}
        </router-link>
      </div>
    </div>

    <div class="intro-y mt-5">
      <router-view :officer="officer"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { OFFICER_REQUEST } from '@/store/actions/officer';
import PageHeader from '@/components/ui/PageHeader';
import Button from '@/components/ui/button/Button';
import OfficerInfo from '@/components/officer/OfficerInfo';

export default {
  components: {
    PageHeader,
    OfficerInfo,
    Button,
  },

  computed: {
    ...mapGetters(['officer', 'officerStatus']),
    isLoading() {
      return this.officerStatus === 'loading' || !this.officer;
    },
  },

  watch: {
    '$route.params.officerId': 'fetchData',
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      try {
        await this.$store.dispatch(OFFICER_REQUEST, this.$route.params.officerId);
      } catch (error) {
        this.$router.push({ name: 'Officers' });
      }
    },
  },
};
</script>
